(function (ws) {
    'use strict';
    ws.models.threePLCartModel = Backbone.Model.extend({

        /**
         * URL
         * @returns {string}
         */
        url: function () {
            return globals.path.api.westcon.addTo3PLCart;
        }

    });
})(westcon);
